import { Flex, Image } from "@chakra-ui/react";
import { ColumnDef, Row } from "@tanstack/react-table";
import { accountLogoFallbackImage } from "const";
import { BuyingGroupProfileButton } from "./components/BuyingGroupProfile";
import { QuantumDemandRow } from "./QuantumDemand.types";

export const quantumDemandColumns: ColumnDef<QuantumDemandRow>[] = [
  {
    header: "",
    accessorKey: "logoUrl",
    enableSorting: false,
    cell: ({ row }: { row: Row<QuantumDemandRow> }) => (
      <Flex>
        <Image
          minW="35px"
          boxSize="35px"
          objectFit="contain"
          src={row.original.logoUrl}
          fallbackSrc={accountLogoFallbackImage}
        />
      </Flex>
    ),
  },
  {
    header: "Domain",
    accessorKey: "domain",
  },
  {
    header: "Quantum Index",
    accessorKey: "quantumIndex",
  },
  {
    header: "Buying Group Profile",
    accessorKey: "domain",
    id: "buyingGroupProfile",
    enableSorting: false,
    cell: ({ row }: { row: Row<QuantumDemandRow> }) => (
      <BuyingGroupProfileButton domain={row.original.domain} />
    ),
  },
];
